var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    key: 0,
    type: "hidden",
    name: "type",
    value: "dynamic"
};
var _hoisted_2 = { class: "list list--md" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = { class: "line" };
var _hoisted_5 = { class: "line__item" };
var _hoisted_6 = ["data-type"];
var _hoisted_7 = { class: "btn__icon" };
var _hoisted_8 = {
    key: 0,
    class: "line__item line__item--mla"
};
var _hoisted_9 = {
    href: "/profile/addresses/",
    class: "btn btn--4 btn--s btn--black"
};
var _hoisted_10 = { class: "btn__icon" };
var _hoisted_11 = { class: "line line--aic" };
var _hoisted_12 = { class: "line__item line__item--mla" };
var _hoisted_13 = ["disabled"];
import Icon from "../../components/Icon.vue";
import ModalDialog from "../../components/modal/ModalDialog.vue";
import DeliveryAddress from "../../components/delivery/DeliveryAddress.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import { hidePreloader, showPreloader } from "../../components/preloader";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressSelectApp',
    props: /*@__PURE__*/ _mergeModels({
        addresses: { type: Array, default: [] },
        address: { type: Object },
        noRedirect: Boolean,
        userLoggedIn: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["select"], ["update:modelValue"]),
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var selected = _useModel(__props, "modelValue");
        var modal = ref();
        var disabled = computed(function () { var _a; return !((_a = props.addresses.find(function (a) { return a.address.id === selected.value; })) === null || _a === void 0 ? void 0 : _a.delivery.available); });
        var emit = __emit;
        __expose({
            show: function () { return modal.value.open(); },
            showLoader: function () { return showPreloader(modal.value.isOpen() ? modal.value.wrapper.querySelector('.modal__wrapper') : null); },
        });
        function onSave(event) {
            var _a;
            var current = props.addresses.find(function (_a) {
                var address = _a.address;
                return address.id === selected.value;
            });
            if (!((_a = current.delivery) === null || _a === void 0 ? void 0 : _a.available)) {
                event.stopPropagation();
                event.preventDefault();
                return false;
            }
            emit('select', current.address, current.delivery);
            if (props.noRedirect) {
                modal.value.close();
                setTimeout(hidePreloader);
            }
        }
        watch(function () { return props.address; }, function (address) { return selected.value = address === null || address === void 0 ? void 0 : address.id; });
        onBeforeMount(function () { var _a; return selected.value = (_a = props.address) === null || _a === void 0 ? void 0 : _a.id; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ModalDialog, {
                id: "addresses",
                size: "lg",
                title: "Выбор способа доставки",
                ref_key: "modal",
                ref: modal,
                open: !__props.noRedirect,
                noRedirect: __props.noRedirect
            }, _createSlots({
                main: _withCtx(function () { return [
                    (__props.noRedirect)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_1))
                        : _createCommentVNode("v-if", true),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.addresses, function (item) {
                            var _a;
                            return (_openBlock(), _createElementBlock("li", {
                                class: "list__item",
                                key: item.address.id
                            }, [
                                _createVNode(DeliveryAddress, {
                                    address: item.address,
                                    delivery: item.delivery,
                                    available: (_a = item.delivery) === null || _a === void 0 ? void 0 : _a.available,
                                    bordered: "",
                                    radio: "",
                                    modelValue: selected.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((selected).value = $event); })
                                }, null, 8 /* PROPS */, ["address", "delivery", "available", "modelValue"])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        (__props.noRedirect)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--4 btn--s btn--black win",
                                            "aria-controls": "modal-add-address",
                                            "data-act": "edit_address",
                                            "data-type": __props.noRedirect ? 'dynamic' : null
                                        }, [
                                            _createElementVNode("span", _hoisted_7, [
                                                _createVNode(Icon, { name: "add" })
                                            ]),
                                            _cache[2] || (_cache[2] = _createTextVNode()),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "btn__label" }, "Добавить", -1 /* CACHED */))
                                        ], 8 /* PROPS */, _hoisted_6)
                                    ]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (__props.userLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("a", _hoisted_9, [
                                                _createElementVNode("span", _hoisted_10, [
                                                    _createVNode(Icon, { name: "edit" })
                                                ]),
                                                _cache[4] || (_cache[4] = _createTextVNode()),
                                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]; }),
                bottom: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "line__item" }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--2 btn--m btn--gray",
                                "data-close": ""
                            }, [
                                _createElementVNode("span", { class: "btn__label" }, "Отмена")
                            ])
                        ], -1 /* CACHED */)),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn--2 btn--m btn--black ajax_submit",
                                "data-act": "select_address",
                                disabled: disabled.value,
                                onClick: onSave
                            }, __spreadArray([], __read((_cache[9] || (_cache[9] = [
                                _createElementVNode("span", { class: "btn__label" }, "Сохранить", -1 /* CACHED */)
                            ]))), false), 8 /* PROPS */, _hoisted_13)
                        ])
                    ])
                ]; }),
                _: 2 /* DYNAMIC */
            }, [
                (!__props.noRedirect)
                    ? {
                        name: "under_top",
                        fn: _withCtx(function () { return [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal__under-top" }, [
                                _createElementVNode("div", { class: "text text--sm" }, [
                                    _createTextVNode("\n          Добавить новые и изменить существующие способы доставки можно на странице «"),
                                    _createElementVNode("a", { href: "/profile/addresses/" }, "Адреса доставки"),
                                    _createTextVNode("»\n        ")
                                ])
                            ], -1 /* CACHED */))
                        ]; }),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["open", "noRedirect"]));
        };
    }
});
